/**
 * 常用方法库 
 * @module Method
 */

;(function (ui,$) {

    /**
     * 常用小方法
     * @namespace  bui
     * @class  unit
     */
    ui.unit = {};

    /**
     * rem的值转换成px 
     * @namespace  bui
     * @method  remToPx
     * @constructor 
     * @param {string} size [ rem的值 ]
     * @example
     *      var size = ui.unit.remToPx(2);
     
     * 
     */
    ui.unit.remToPx = function (size) {

        var htmlSize = window.viewport.fontSize,
            // 比例的换算
            size = ( parseFloat(size) * htmlSize ).toFixed(2);

        return size;

    };
    /**
     * px的值转换成rem
     * @namespace  bui
     * @method  pxToRem
     * @constructor 
     * @param {string} size [ px的值 ]
     * @example
     *      var size = ui.unit.pxToRem(200);
     
     * 
     */
    ui.unit.pxToRem = function (size) {

        var htmlSize = window.viewport.fontSize,
            // 比例的换算
            size = ( parseFloat(size) / htmlSize ).toFixed(2);

        return size;
    };
    /**
     * px等比转换rem
     * @namespace  bui
     * @method  pxToRemZoom
     * @constructor 
     * @param {string} size [ px的值 ]
     * @example
     *      var size = ui.unit.pxToRemZoom(200);
     
     * 
     */
    ui.unit.pxToRemZoom = function (size) {

        var htmlSize = 100,
            // 比例的换算
            size = ( parseFloat(size) / htmlSize ).toFixed(2);

        return size;
    };

    return ui;

})( bui || {}, libs );
